var icon_button_rtlignore_default = {
  "audioIconButton": "Ct7R6"
};
export {
  icon_button_rtlignore_default as default
};
//# sourceMappingURL=icon-button.rtlignore-scss.js.map
